<template>
  <div class="draggable-task-cpt">
    <div class="task-list">
      <draggable
        v-model="localDatas"
        group="task"
        handle=".task-item-ft"
        @change="handleTaskSort"
      >
        <div class="task-item" v-for="(item, index) in localDatas" :key="index">
          <div class="task-item-hd">
            <div class="task-item-hd-lt">
              <el-input
                size="small"
                v-model="item.name"
                placeholder="请输入任务名称"
                :disabled="disabled"
              >
              </el-input>
            </div>
            <div class="task-item-hd-rt">
              <el-input
                size="small"
                style="width: 140px;"
                v-model.number="item.duration"
                :disabled="disabled"
              >
                <template slot="append">小时</template>
              </el-input>
            </div>
          </div>
          <div class="task-item-bd">
            <el-input
              type="textarea"
              placeholder="请输任务简介"
              v-model="item.description"
              :disabled="disabled"
            />
          </div>
          <div class="task-item-ft">#{{ index + 1 }}</div>
          <div
            class="task-item-del"
            @click="removeTask(item)"
            v-show="!disabled"
          >
            <i class="el-icon-remove" type="danger"></i>
          </div>
        </div>
      </draggable>
    </div>
    <div class="task-add-container w-90pc" v-show="!disabled">
      <el-button class="task-add" @click="addTask">添加项目</el-button>
    </div>
  </div>
</template>

<script type="text/javascript">
import draggable from "vuedraggable";
export default {
  components: {
    draggable
  },
  props: {
    datas: {
      type: Array,
      default: () => []
    },
    disabled: {
      type: Boolean,
      default: false
    }
  },
  watch: {
    datas(val) {
      this.localDatas = val;
    },
    localDatas(val) {
      this.$emit("update:datas", val);
    }
  },
  data() {
    return {
      localDatas: []
    };
  },
  methods: {
    addTask() {
      let tId = Date.now();
      this.datas.push({
        tId,
        name: "",
        description: "",
        duration: null,
        contents: []
      });
    },
    removeTask(item) {
      this.$confirm(
        "此操作将永久删除项目「" + item.name + " 」, 是否继续?",
        "提示",
        {
          confirmButtonText: "确定",
          cancelButtonText: "取消",
          type: "warning"
        }
      ).then(() => {
        const index = this.datas.indexOf(item);
        this.datas.splice(index, 1);
        this.$message({
          type: "success",
          message: "删除成功!"
        });
      });
    },
    handleTaskSort() {}
  }
};
</script>

<style type="text/css" lang="less" scoped>
.task-list {
  position: relative;
  border-radius: 4px;
  // border: 1px solid #DCDFE6;
  background-color: #fff;
  padding: 12px 0;
  box-shadow: 0 1px 4px 0 rgba(31, 35, 41, 0);
}
.task-item {
  position: relative;
  width: 90%;
  padding: 0 0 0 40px;
  // border-bottom: 1px solid #DCDFE6;
  .task-item-hd {
    display: flex;
    align-items: center;
    position: relative;
    height: 32px;
    line-height: 32px;
    // border-bottom: 1px solid #DCDFE6;
    .task-item-hd-lt {
      flex: 1;
      height: 32px;
    }
    .task-item-hd-rt {
      margin-left: 12px;
      /*position: absolute;
      right: 0;
      top: 50%;
      transform: translateY(-50%);*/
    }
  }
  .task-item-bd {
    padding: 6px 0;
  }
  .task-item-ft {
    position: absolute;
    left: 0;
    top: 20px;
    color: #999;
    font-size: 14px;
  }
  .task-item-del {
    position: absolute;
    right: -26px;
    top: 20px;
    cursor: pointer;
    color: #909399;
    transition: all 0.2s ease;
    &:hover {
      color: #f56c6c;
    }
  }
}
.task-add-container {
  .task-add {
    width: 100%;
  }
}
/deep/.el-input-group__append {
  border: none;
}
</style>
